import { render, staticRenderFns } from "./BatchDramaReviewsPerson.vue?vue&type=template&id=fd75303a&scoped=true"
import script from "./BatchDramaReviewsPerson.vue?vue&type=script&lang=js"
export * from "./BatchDramaReviewsPerson.vue?vue&type=script&lang=js"
import style0 from "./BatchDramaReviewsPerson.vue?vue&type=style&index=0&id=fd75303a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd75303a",
  null
  
)

export default component.exports